import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconShieldLock, IconCookie } from '@tabler/icons-react';
import { KamaModal } from './KamaModal';

export const RenderFooter = () => {
    const { t, i18n } = useTranslation();
    const [showModal, setShowModal] = useState(null);

    const openModal = (type) => setShowModal(type);
    const closeModal = () => setShowModal(null);

    const linkStyle = {
        color: 'rgba(255,255,255,0.4)',
        fontSize: '12px',
        cursor: 'pointer',
        textDecoration: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
        transition: 'color 0.2s',
    };

    return (
        <footer style={{
            background: '#1e2a38',
            borderTop: '1px solid rgba(255,255,255,0.06)',
            padding: '16px 28px',
        }}>
            <div style={{
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
            }}>

                {/* Sol: Logo + telif hakkı */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        display: 'inline-flex', alignItems: 'center',
                    }}>
                        <img src="Kama3DLogo.svg" alt="Kama 3D" style={{ height: 28 }} />
                    </div>
                    <span style={{ color: 'rgba(255,255,255,0.28)', fontSize: '12px' }}>
                        © {new Date().getFullYear()} Kama 3D Doküman Merkezi
                    </span>
                    <span style={{ color: 'rgba(255,255,255,0.12)' }}>|</span>
                    <span style={{ color: 'rgba(255,255,255,0.28)', fontSize: '12px' }}>
                        Developed by &copy; <a 
                            href="https://tecom.com.tr" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ 
                                color: 'inherit', 
                                textDecoration: 'none', 
                                transition: 'color 0.2s',
                                fontWeight: 500
                            }}
                            onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
                            onMouseLeave={e => e.target.style.color = 'inherit'}
                        >
                            Tecom Bilişim
                        </a>
                    </span>
                </div>

                {/* Sağ: Bağlantılar */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
                    {i18n.language.startsWith('tr') && (
                        <>
                            <button onClick={() => openModal('kvkk')} style={linkStyle}
                                onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
                                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}
                            >
                                Kişisel Verilerin Korunması
                            </button>
                            <span style={{ color: 'rgba(255,255,255,0.12)' }}>|</span>
                            <button onClick={() => openModal('cerez')} style={linkStyle}
                                onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
                                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}
                            >
                                Çerez Politikası
                            </button>
                            <span style={{ color: 'rgba(255,255,255,0.12)' }}>|</span>
                        </>
                    )}
                    <a
                        href="https://e-sirket.mkk.com.tr/?page=company&company=15383"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={linkStyle}
                        onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
                        onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}
                    >
                        Bilgi Toplumu Hizmetleri
                    </a>
                </div>
            </div>

            <KamaModal
                show={showModal !== null}
                onHide={closeModal}
                title={showModal === 'kvkk' ? 'Kişisel Verilerin Korunması' : 'Çerez Politikası'}
                icon={showModal === 'kvkk' ? <IconShieldLock size={20} /> : <IconCookie size={20} />}
                size="lg"
                footer={
                    <button className="btn btn-primary fw-bold px-5" onClick={closeModal}>
                        {t('butonKapat')}
                    </button>
                }
            >
                <iframe
                    src={showModal === 'kvkk' ? '/kvkk.html' : '/cerez-politikasi.html'}
                    title={showModal === 'kvkk' ? 'Kişisel Verilerin Korunması' : 'Çerez Politikası'}
                    style={{ width: '100%', height: '65vh', border: 'none', display: 'block' }}
                />
            </KamaModal>
        </footer>
    );
};
